module.exports = __webpack_public_path__ + "static/Guide-e081906ea8df67c294e32fc88d822e34.pdf";